// extracted by mini-css-extract-plugin
export default {"container":"ScreenShot_container__7D3EU","background":"ScreenShot_background__aqM7w","wrapper":"ScreenShot_wrapper__zdBsv","fullScreen":"ScreenShot_fullScreen__4l52B"};